import {t} from 'i18next'
import {ColumnFilterElementTemplateOptions} from 'primereact/column'
import {Dropdown} from 'primereact/dropdown'
import React from 'react'
import {Apprentice} from '../../../model/person.model'
import {findApprenticeById} from '../../../util/arraySearch'
import {AvatarWithName} from '../AvatarWithName'

const apprenticeOptionFilterTemplate = (id: number, apps: Apprentice[]) => {
	let p = findApprenticeById(id, apps)
	if (!p) {
		return t<string>('core.all')

	}
	return <AvatarWithName person={p}/>
}

export const apprenticeFilterTemplate = (options: ColumnFilterElementTemplateOptions, apps: Apprentice[]): JSX.Element => {

	const filterValues: any = []
	apps.forEach(apprentice => {
		if (apprentice.apprentice?.apprentice_id) {
			filterValues.push({
				label: apprentice.full_name,
				value: apprentice.apprentice.apprentice_id
			})
		}

	})

	return <Dropdown value={options.value} options={filterValues}
	                 valueTemplate={_ => apprenticeOptionFilterTemplate(options.value, apps)}
	                 itemTemplate={e => apprenticeOptionFilterTemplate(e.value, apps)}
	                 onChange={e => {
						options.filterApplyCallback(e.value)
					 }}
	                 placeholder={t<string>('core.all')}
	                 filter
	                 style={{height: 40, minHeight: 40, width: '100%', minWidth: '100%', maxWidth: '120px'}}
	                 className="p-column-filter"/>

}